export interface IMicrositeCoachRankData {
    coachId: number,
    newPatientAssignmentsTotal: number,
    activeMicrositesTotal: number,
    activatedMicrositesTotal: number,
    livingDonorTransplantsTotal: number,
    deceasedDonorTranplantsTotal: number,
    deactivatedMicrositesTotal: number,
    livingDonorTxpsPast12MonthsTotal: number,
    successRateCurrentMonthTotal: number,
    SuccessRatePast12MonthsTotal: number,

    newPatientAssignmentsRank: number,
    activeMicrositesRank: number,
    livingDonorTransplantsRank: number,
    deceasedDonorTransplantsRank: number,
    deactivatedMicrositesRank: number,
    livingDonorTransplantsPast12MonthsRank: number,
    successRateCurrentMonthRank: number,
    successRatePast12MonthsRank: number
}